// extracted by mini-css-extract-plugin
module.exports = {"tabs":"DictionariesTabsPage_tabs__1Zzb7","width-select":"DictionariesTabsPage_width-select__HMmEK","bp3-fill":"DictionariesTabsPage_bp3-fill__1-JRc"};